import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import api from '../utils/api';

const STATUS_COLORS = { pending: 'badge-yellow', processing: 'badge-yellow', shipped: 'badge-green', delivered: 'badge-green', cancelled: 'badge-red', refunded: 'badge-gray' };

export default function Orders() {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) { navigate('/login'); return; }
    api.get('/orders/my').then(r => setOrders(r.data.orders)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container" style={{ padding: '2.5rem 0' }}>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '2rem' }}>My Orders</h1>
      {loading ? <div className="loading-center"><div className="spinner" /></div> : orders.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: 'var(--gray-400)' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📦</div>
          <h2>No orders yet</h2>
          <p style={{ marginBottom: '1.5rem' }}>Your research compounds will appear here after purchase.</p>
          <Link to="/shop" className="btn btn-primary">Start Shopping</Link>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {orders.map(order => (
            <div key={order.id} className="card" style={{ padding: '1.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>
                <div>
                  <p style={{ fontSize: '0.8125rem', color: 'var(--gray-400)' }}>Order Number</p>
                  <strong style={{ fontFamily: 'monospace', fontSize: '1rem' }}>{order.orderNumber}</strong>
                </div>
                <span className={`badge ${STATUS_COLORS[order.status] || 'badge-gray'}`} style={{ fontSize: '0.875rem', padding: '0.375rem 1rem' }}>
                  {order.status?.toUpperCase()}
                </span>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', fontSize: '0.875rem', color: 'var(--gray-600)', marginBottom: '1rem' }}>
                <span>📅 {new Date(order.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                <span>📦 {order.items?.length} item(s)</span>
                <span>💰 Total: <strong>${order.total?.toFixed(2)}</strong></span>
                <span>🚚 Shipping: {order.shipping === 0 ? 'FREE' : `$${order.shipping?.toFixed(2)}`}</span>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                {order.items?.map(i => (
                  <span key={i.key} style={{ background: 'var(--gray-100)', padding: '0.25rem 0.75rem', borderRadius: 999, fontSize: '0.8125rem' }}>
                    {i.name} × {i.quantity}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
